import { observe } from "jotai-effect";
import { saveState } from "utilities/atoms/conversations/conversations.persistence";
import {
    BookviewConversationAtom,
    ModalConversationAtom,
    NotebookConversationAtom,
} from "./current-conversation/conversation-atoms";
import { ConversationHistoryAtom } from "./conversation-history/conversation-history-atom";

export function conversationsAtomPersistenceEffect() {
    return observe((get) => {
        const modalConversation = get(ModalConversationAtom);
        const bookviewConversation = get(BookviewConversationAtom);
        const notebookConversation = get(NotebookConversationAtom);
        const conversationHistory = get(ConversationHistoryAtom);

        saveState("modalConversation", modalConversation);
        saveState("bookviewConversation", bookviewConversation);
        saveState("notebookConversation", notebookConversation);
        saveState("conversationHistory", conversationHistory);
    });
}
